import { render } from "./PresentationSlideSeven.vue?vue&type=template&id=5f062f5d&scoped=true"
const script = {}

import "./PresentationSlideSeven.vue?vue&type=style&index=0&id=5f062f5d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f062f5d"]])

export default __exports__